import Dialog from "../../atoms/dialog";
import { Button, Typography, Box } from "@material-ui/core";
import { useState, useEffect, Fragment } from 'react'
import DeleteHandler from "../handlers/DeleteHandler";

export default function DeleteHandlerAlert({ onCompletion, id, onClose, handlerType, category, element, handlerAssociatedEvent }) {

    const [open, setOpen] = useState(false)

    const handleClose = () => {
        setOpen(false);
        onClose();
    }

    return (

        <Dialog
            // title={"Delete"}
            open={true}
            handleClose={handleClose}
        >

            <DeleteHandler onCompletion={onCompletion} id={id} onClose={onClose} handlerType={handlerType} category={category} element={element} handlerAssociatedEvent={handlerAssociatedEvent} />

        </Dialog >
    )


}